
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/anxiety",
      function () {
        return require("private-next-pages/anxiety.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/anxiety"])
      });
    }
  